var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogicBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,18 C2.34314575,18 1,16.6568542 1,15 C1,13.3431458 2.34314575,12 4,12 C5.65685425,12 7,13.3431458 7,15 C7,16.6568542 5.65685425,18 4,18 Z M4,16 C4.55228475,16 5,15.5522847 5,15 C5,14.4477153 4.55228475,14 4,14 C3.44771525,14 3,14.4477153 3,15 C3,15.5522847 3.44771525,16 4,16 Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 6,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 15,
  r: 3
}), /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 14,
  width: 11,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 5,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,5 L10,15 L8,15 L8,7 C8,5.8954305 8.8954305,5 10,5 Z"
})))));
export default SvgLogicBranch;